const isNumber = data => {
  return !isNaN(parseFloat(data)) && isFinite(data);
};
const isEmail = data => {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(data);
};
const isPhoneNumber = (data, required = false) => {
  if (required && !data) return false;
  const phoneRegex =
    /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d| 2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]| 4[987654310]|3[9643210]|2[70]|7|1)\d|[0123]\d{1,14}$/;
  return phoneRegex.test(data);
};
export { isNumber, isEmail, isPhoneNumber };



// WEBPACK FOOTER //
// ./src/app/common/utils/validate.ts